import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ReactPaginate from 'react-paginate';
import { customerActions } from '../../../_actions';
import { TbChevronLeft } from "react-icons/tb";
import Input from '../../../components/ui/Input/Input';
import { formatWithOffset } from '../../../_helpers/helper';

const CustomerView = ({ handleView, allCustomerSelected, handleAddAllCustomer, handleAddCustomer, selectedIds, setSelectedIds, handleSelectUser }) => {
  const [searchText, setSearchText] = useState("");

  const adminData = useSelector((state) => state.users.adminData);
  const userAccess = adminData?.access?.split(",");
  const assignedCustomer = userAccess?.includes("view_customer") ? true : false;
  const size = 8;
  const theadData = [
    "Name",
    "Phone",
    "City",
    "Weighbridge Id",
    "License Key",
    "Referred By",
    "Expired On",
    "Last Login",
    'Status',
  ];
  const dispatch = useDispatch();
  const handlePageClick = (e) => {
    dispatch(customerActions.customerList({
      sortBy: "id",
      sortOrder: "DESC", size: size, page: e.selected + 1
    }, assignedCustomer));
  }
  const tbodyData = useSelector(state => state.customer.customer);
  const [sortOrder, setSortOrder] = useState("DESC");
  const isExpiringSoon = (expiredOn) => {
    if (!expiredOn) return false;
    const currentDate = new Date();
    const expiryDate = new Date(expiredOn);
    const timeDifference = expiryDate - currentDate;
    const daysDifference = timeDifference / (1000 * 60 * 60 * 24);
    return daysDifference <= 7 && daysDifference >= 0;
  }
  const isExpired = (expiredOn) => {
		if (!expiredOn) return false;
		const currentDate = new Date();
		const expiryDate = new Date(expiredOn);
		return currentDate > expiryDate;
	}
  useEffect(() => {
    dispatch(customerActions.customerList({
      keyWord: searchText, sortBy: "id",
      sortOrder: "DESC",
    }, assignedCustomer));
  }, [searchText, assignedCustomer]);
  function sortFunction(index) {
    const sortKey = ['f_name', 'weighbridge_id', 'expired_on', 'phone', 'referred_by_name', 'license_key', 'last_login', 'city', 'status'];
    if (!sortKey[index]) return;
    dispatch(customerActions.customerList({ sortBy: sortKey[index], sortOrder: sortOrder }, assignedCustomer));
    if (sortOrder === "ASC") {
      setSortOrder("DESC");
    } else {
      setSortOrder("ASC");
    }
  }
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = tbodyData && tbodyData.list && tbodyData.list.length > 0 ? tbodyData.list?.map((user) => user.id) : [];
      setSelectedIds([...new Set([...selectedIds, ...allIds])]);
    } else {
      const allIds = tbodyData && tbodyData.list && tbodyData.list.length > 0 ? tbodyData.list.map((user) => user.id) : [];
      setSelectedIds([...new Set(selectedIds.filter((id) => !allIds.includes(id)))]);
    }
  };
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-lg shadow-lg w-[90%] max-w-6xl   overflow-hidden overflow-y-auto  h-[90vh]">

        <div className="flex justify-between items-center border-b p-4">
          <div className='flex items-center space-x-3'>
            <button onClick={handleView} className="text-back hover:text-red-500 flex-shrink-0 bg-gray-100 rounded-full p-2 ">
              <TbChevronLeft size={24} className='  ' />
            </button>
            <h2 className="text-xl font-semibold text-[#212121]">Recently Added Customers</h2>
          </div>
          {/* <button className='bgbtn px-5 py-1 rounded-md' onClick={handleAddAllCustomer}>{allCustomerSelected ? "Remove All Customer" : "Add All" }</button> */}
          {/* <button className='bgbtn px-5 py-1 rounded-md' onClick={handleAddCustomer}>Add</button> */}
        </div>

        <div className=" space-y-4">
          <div className='px-4 pt-4'>
            <Input className="w-96" placeholder={`Search...`} value={searchText} onChange={(e) => setSearchText(e.target.value)} />
          </div>
          <div className=' overflow-x-auto px-4 h-[600px] overflow-y-auto'>
            <table className="min-w-full text-sm text-left text-gray-500  border ">
              <thead className="text-black capitalize border-b bg-gray-100">
                <tr>
                  <th className="px-4 py-2 whitespace-nowrap space-x-3 font-medium text-gray-900">
                    <input type="checkbox" className='border border-[#D8D8D8]' onChange={handleSelectAll}
                      checked={tbodyData && tbodyData.list && Array.isArray(tbodyData.list) && tbodyData.list.every(user => selectedIds.includes(user.id))} />
                    <span>#</span>
                  </th>
                  {theadData.map((header, index) => (
                    <th key={index} className="px-4 py-2 whitespace-nowrap font-medium text-gray-900" onClick={() => sortFunction(index)}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {tbodyData && tbodyData.total != 0 && tbodyData.list.map((row, index) => (
                  <tr key={index} className={`bg-white whitespace-nowrap hover:bg-gray-100 font-normal text-[#212121] border-b capitalize ${isExpiringSoon(row.expired_on) ? "bg-red-500" : ""}`}>
                    <td className="px-4 py-2 space-x-3">
                      <input type="checkbox" className='border border-[#D8D8D8] pr-2'
                        checked={selectedIds?.includes(row.id)}
                        onChange={() => handleSelectUser(row.id)}
                      />
                      <span>{row.id}</span>
                    </td>
                    <td className="px-4 py-2"> {row?.f_name} </td>
                    <td className="px-4 py-2">{row.phone}</td>
                    <td className="px-4 py-2">{row.city}</td>
                    <td className="px-4 py-2">{row.weighbridge_id}</td>
                    <td className="px-4 py-2">{row.license_key}</td>
                    <td className="px-4 py-2">{row.referred_by_name}</td>
                    <td className="px-4 py-2">{formatWithOffset(row.expired_on)}</td>
                    <td className="px-4 py-2">{formatWithOffset(row.last_login)}</td>
                    <td
                      className={`px-4 py-2 ${row?.expire_on_backup ? 'text-red-500' : isExpired(row?.expired_on) ? 'text-yellow-500' : 'text-green-500'}`}
                    >
                      {row?.expire_on_backup ? 'Stoped' : isExpired(row?.expired_on) ? 'Expired' : 'Active'}
                    </td>
                    {/* <td className={`px-4 py-2 ${row.status === 1 ? 'text-green-500' : row.status === 2 ? 'text-red-500' : 'text-yellow-500'}`}>{row.status === 1 ? 'Active' : row.status === 2 ? 'Stoped' : 'Expired'}</td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {tbodyData && tbodyData.total === 0 && <div className='flex items-center justify-center mt-[20px]'><h2>Customer not exists.</h2></div>}
        </div>
        {/* <div className='flex gap-[20px]'>
                    <button onClick={handleView}>Close</button>
                    <button onClick={handleAddCustomer}>Add</button>
                </div> */}
        {tbodyData && tbodyData.total && tbodyData.total > size &&
          <div className='pt-10 p-6'>
            <ReactPaginate
              previousLabel={'Prev'}
              nextLabel={'Next'}
              breakLabel={'...'}
              breakClassName={'break-me'}
              pageCount={tbodyData.total / size}
              marginPagesDisplayed={1}
              pageRangeDisplayed={1}
              onPageChange={handlePageClick}
              containerClassName={'pagination'}
              pageClassName={'page-cls'}
              activeClassName={'active'}
              total={tbodyData.total}
              size={size}
            />
          </div>}
      </div>
    </div>
  )
}

export default CustomerView